<template>
  <div>
    <img class="fullBody z-10" src="../../assets/Tutorial/fullBody.svg" />
  </div>
</template>

<script>
export default {
  name: 'FullBody',
};
</script>

<style lang="scss" scoped>
.fullBody {
  height: 55vw;
}
</style>
